<template>
    <TprmModal
        additional-class-name="SendTestEmailModal"
        :allow-close="!submitting"
        :open="open"
        :title="`Send a ${verificationType} Test Email`"
        subtitle="Test your email before sending to your entities."
        @close="$emit('close')"
    >
        <div class="SendTestEmailModal__emailLabel">
            Email Address
        </div>
        <div class="SendTestEmailModal__email">
            {{ userEmail }}
        </div>
        <template v-if="audienceChoice">
            <div class="SendTestEmailModal__emailLabel">
                Send the email as
            </div>
            <div class="SendTestEmailModal__audience">
                <RadioOption
                    name="testEmailAudience"
                    :value="audiences.entity"
                    :checked="audience === audiences.entity"
                    @input="audience = audiences.entity"
                >
                    Entity
                </RadioOption>
                <RadioOption
                    name="testEmailAudience"
                    :value="audiences.producer"
                    :checked="audience === audiences.producer"
                    @input="audience = audiences.producer"
                >
                    Producer
                </RadioOption>
            </div>
        </template>
        <template #footer>
            <NewButton
                :loading="submitting"
                :disabled="submitting"
                color="primary"
                @click="onSubmit"
            >
                Send Test
            </NewButton>
        </template>
    </TprmModal>
</template>

<style lang="scss">
    .SendTestEmailModal__audience {
        display: flex;
        gap: 24px;
    }
</style>

<script lang="ts">
    import { Component, Prop, Vue } from '@evidentid/vue-property-decorator';

    import startCase from 'lodash/startCase';

    import { RadioOption } from '@evidentid/dashboard-commons/components/RadioOption';
    import { useUserStore } from '@evidentid/dashboard-commons/modules/auth/store/user';
    import { NotificationAudience } from '@evidentid/tprm-portal-lib/models/notification-configuration';
    import {
        VerificationRequestType,
    } from '@evidentid/tprm-portal-lib/models/notification-configuration/VerificationRequest.model';

    import NewButton from '@/components/new-button/NewButton.vue';
    import TprmModal from '@/components/tprm-modal/TprmModal.vue';

    // PRODUCT-26110 QA fixes4: declares every event this component `$emit`s -- without a
    // declared `emits`, Vue 3 warns "Component emitted event 'close'/'submit' but it is
    // neither declared in the emits option nor as an 'onClose'/'onSubmit' prop" every
    // time it fires.
    @Component({
        components: {
            NewButton,
            RadioOption,
            TprmModal,
        },
        emits: [ 'close', 'submit' ],
    })
    export default class SendTestEmailModal extends Vue {
        @Prop({ type: Boolean, default: false })
        private submitting!: boolean;

        @Prop({ type: Boolean, default: false })
        private open!: boolean;

        @Prop({ type: String })
        private type!: VerificationRequestType;

        // Shown with producer flow on, for a type producers receive.
        @Prop({ type: Boolean, default: false })
        private audienceChoice!: boolean;

        private audiences = NotificationAudience;
        private audience: NotificationAudience = NotificationAudience.entity;

        private get verificationType(): string {
            return this.type === VerificationRequestType.nonCompliant
                ? 'Non-compliant'
                : startCase(this.type.toLowerCase());
        }

        private get userEmail(): string {
            return useUserStore().data?.email || '';
        }

        private onSubmit(): void {
            if (this.submitting) {
                return;
            }
            this.$emit('submit', this.audienceChoice ? this.audience : undefined);
        }
    }
</script>
